// extracted by mini-css-extract-plugin
export default {"productProposition":"N4yM_1Rlxa0ZFGw0OZ27"};